import { Button, Modal, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { type TEditColumnData } from 'components/data/types';

import BulkEditForm from './BulkEditForm';

interface Props {
  records: any[];
  columns: TEditColumnData[];
  requiredFields?: string[];
  onSubmit: (data: any) => void;
  btnDisplay?: boolean;
  disabled?: boolean;
  disabledMessage?: string;
  additionalTooltipContent?: string;
  additionalFooterContent?: React.ReactNode;
}

export const BulkEdit: React.FunctionComponent<Props> = ({
  records,
  columns,
  requiredFields = [],
  onSubmit,
  btnDisplay = true,
  disabled = false,
  disabledMessage = '',
  additionalTooltipContent = '',
  additionalFooterContent,
}) => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState(false);

  function closeModal() {
    setModalVisible(false);
  }

  useEffect(() => {
    return () => {
      setModalVisible(false);
    };
  }, []);

  return (
    <>
      {btnDisplay ? (
        <Tooltip title={disabled ? disabledMessage : ''}>
          <div>
            <Button
              id="bulk-edit-button"
              data-testid="bulk-edit-button"
              onClick={() => setModalVisible(true)}
              disabled={disabled}
            >
              {t('table.editSelected', 'Edit Selected')}
            </Button>
          </div>
        </Tooltip>
      ) : (
        <div onClick={() => setModalVisible(true)}>{t('table.editSelected', 'Edit Selected')}</div>
      )}
      <Modal
        title={t('assets.editItemsButton', 'Edit {{count}} items', { count: records.length })}
        open={modalVisible}
        onCancel={closeModal}
        footer={null}
        destroyOnHidden
      >
        <BulkEditForm
          columns={columns}
          records={records}
          requiredFields={requiredFields}
          onSubmit={onSubmit}
          onClose={closeModal}
          additionalTooltipContent={additionalTooltipContent}
          additionalFooterContent={additionalFooterContent}
        />
      </Modal>
    </>
  );
};
